import Api from "../axios";

export const deletePolicyNotice = ({ id }) => {
  return Api.delete(`delete_policy_notice?policy_id=${id}`);
};
